export const rootStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 0.5,
  paddingRight: 1.5,
  color: theme => theme.palette.text.secondary,
};

export const avatarStackStyles = {
  display: 'flex',
  alignItems: 'center',
  '& > *:not(:first-of-type)': {
    marginLeft: '-4px',
  },
};

export const avatarStyles = {
  width: 16,
  height: 16,
  fontSize: 10,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme => theme.palette.background.paper,
};
